import { Scope } from '@wix/ambassador-blog-v3-blog/types';
import {
  ROLE_GUEST_WRITER,
  ROLE_OPEN_BLOG_WRITER,
  ROLE_SERVICE,
  ROLE_USER,
  ROLE_WRITER,
  ROLE_GUEST,
  ROLE_OWNER,
  ROLE_EDITOR,
} from '@wix/communities-blog-universal/dist/src/permissions-checker-constants';
import { type Role } from './types';

export const config: Record<Scope, Role> = {
  [Scope.UNKNOWN_SCOPE]: 'unknown',
  [Scope.OWNER]: ROLE_OWNER,
  [Scope.EDITOR]: ROLE_EDITOR,
  [Scope.WRITER]: ROLE_WRITER,
  [Scope.GUEST]: ROLE_GUEST,
  [Scope.GUEST_WRITER]: ROLE_GUEST_WRITER,
  [Scope.OPEN_BLOG_WRITER]: ROLE_OPEN_BLOG_WRITER,
  [Scope.SERVICE]: ROLE_SERVICE,
  [Scope.USER]: ROLE_USER,
};
